import WidgetBase from '@dojo/widget-core/WidgetBase';
import { DNode } from '@dojo/widget-core/interfaces';
import { v } from '@dojo/widget-core/d';

import * as css from './styles/PlayerInfo.m.css';

import { memberInfo } from './Ticker';
import StatisticManager from '../StatisticManager';

export interface PlayerInfoProperties {
    team: number;
    player: memberInfo;
    rightToLeft: boolean;
}

export default class PlayerInfo extends WidgetBase<PlayerInfoProperties> {
    
    protected render() {
        
        // console.log("PlayerInfo#render", this.properties.team, this.properties.player);
        
        var stats = StatisticManager.getStats(this.properties.team, this.properties.player.player_no);
        
        var playerNo:       DNode = v('div', { title: 'Rückennummer', classes: [ css.playerno ]},
                [this.properties.player.player_no]);
        var playerName:     DNode = v('div', { title: 'Spielername', classes: [ css.playername ]},
                [this.properties.player.prename, ' ', this.properties.player.name]);
        var playerGoals:    DNode = v('div', { title: 'Geworfene Tore', classes: [ css.playergoals  ]},
            [ "" + (stats.scoredGoals || "")]);
        var player7m:       DNode = v('div', { title: 'Geworfene und getroffene 7 Meter',
            classes: [ css.player7m  ]},
            [ stats.thrown7m == 0 ? " / " : stats.thrown7m + "/" + stats.scored7m]);
        var playerWarn:     DNode = v('div', { title: 'Gelbe Karte', classes: [ css.playerwarn ]},
            [stats.warning]);
        var player2m:       DNode[] = [];
        for (var i=0; i<3; i++) {
            player2m[i] =           v('div', { title: '2-Minuten Strafen', classes: [ css.player2m  ]},
                [stats.timeouts[i]]);
        }
        var playerDisq:     DNode = v('div', { title: 'Rote Karte', classes: [ css.playerdisq ]},    
            [stats.disqualify]);
        
        var direction;
        if (this.properties.rightToLeft) {
            direction = css.forwards;
        } else {
            direction = css.forwards;
        }
        
        return v('div',  { classes: [ css.playerbox, direction]}, [ playerNo,
                                    playerName, playerGoals, player7m ,
                                    playerWarn, player2m[0], player2m[1], player2m[2], playerDisq ]
            )
        ;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/PlayerInfo.ts